import React from "react";
import styled from "styled-components";

const Wrap = styled.div`
  display: block;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-align: left;
`;

export default ({ children, title }) => (
  <div>
    <Wrap>{title}</Wrap>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/generic/form/service/Label/index.js